import type { FC } from "react";
import React, { useState } from "react";

import { Button } from "@react/ui-primitives/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@react/ui-primitives/dialog";

import type { Project } from "@apis/memory/models";

import { ConnectGithubRepoDialogContent } from "./ConnectGithubRepoDialogContent.tsx";

interface ConnectGithubRepoDialogProps {
  readonly project: Project;
}

export const ConnectGithubRepoDialog: FC<ConnectGithubRepoDialogProps> = ({
  project,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <Dialog onOpenChange={setOpen} open={open}>
      <DialogTrigger asChild>
        <Button variant="outline">Connect repository</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Connect repository</DialogTitle>
        </DialogHeader>
        <ConnectGithubRepoDialogContent project={project} />
      </DialogContent>
    </Dialog>
  );
};
